import PropTypes from 'prop-types'
import { HeaderTitle } from '../../../../common/HeaderTitle.jsx'
import { SimpleTable } from '../../../../common/simpleTable/SimpleTable.jsx'
import ButtonWithIcon from '../../../../common/ButtonWithIcon.jsx'
import { Icons } from '../../../../common/Icons.jsx'
import { useSelector } from 'react-redux'
import { useState } from 'react'
import { createTableListaProfiliProjektu } from '../../lib/columns/tableListaProfiliProjektu.jsx'
import { useListaProfiliProjktu } from '../../../../../api/domain/elementyRejstru/queries/useListaProfiliProjektu.jsx'
import { useParams } from 'react-router-dom'
import {
    ModalDodajOsobePowiazana,
    ModalOdwiazOsobeOdProjektu,
} from '../../lib/components/modals.jsx'

const ViewListaProfiliProjektu = () => {
    const [currPozycja, setCurrPozycja] = useState({})
    const { id } = useParams()
    const listaPozycji = useListaProfiliProjktu(id)
    const titleName = `Lista operatorów projektu o id: ${id || ''}`
    const [modalState, setModalState] = useState({
        delete: false,
        powiaz: false,
    })
    const rola = useSelector((state) => state.user.role) // to string
    const openModal = (type, data) => {
        setCurrPozycja(data)
        setModalState((prev) => ({ ...prev, [type]: true }))
    }

    const closeModal = (type) =>
        setModalState((prev) => ({ ...prev, [type]: false }))

    const handleAction = (row, type) => {
        openModal(type, row)
    }

    const isWp = rola === 'wp'
    const allow = {
        show: {
            powiaz: isWp,
        },
    }

    const modals = () => (
        <>
            <ModalDodajOsobePowiazana
                show={modalState.powiaz}
                handleClose={() => closeModal('powiaz')}
                currPozycja={currPozycja}
            />
            <ModalOdwiazOsobeOdProjektu
                show={modalState.delete}
                handleClose={() => closeModal('delete')}
                currPozycja={currPozycja}
            />
        </>
    )
    const th = () => {
        if (!isWp) return null
        return (
            <>
                <th>Akcje</th>
            </>
        )
    }

    const td = (row) => {
        const allowItem = {
            show: {
                delete: isWp,
            },
        }
        return (
            <>
                <td>
                    <div className={'d-flex gap-2'}>
                        {allowItem.show.delete && (
                            <ButtonWithIcon
                                onClick={() =>
                                    handleAction({ ...row, id }, 'delete')
                                }
                                // disabled={loading}
                                variant={'danger'}
                                size={'sm'}
                                icon={<Icons.delete />}
                                title='Usuń użytkownika z projektu'
                            />
                        )}
                    </div>
                </td>
            </>
        )
    }

    return (
        <>
            {Object.keys(modalState || {}).some((k) => k) && modals()}
            <HeaderTitle
                breadcrumbLinks={[
                    {label: 'Wszystkie projekty', to: `/${rola}/rejestr/lista`},
                    {label: titleName}
                ]}
                home
                nav
                destination={`/${rola}/rejestr/lista`}
                size={'fs-3'}
                title={titleName}
            />
            <div className={'d-flex justify-content-end gap-3'}>
                {allow.show.powiaz && (
                    <ButtonWithIcon
                        size={'lg'}
                        onClick={() => handleAction({ id }, 'powiaz')}
                        text={'Dodaj użytkownika do projektu'}
                        variant={'primary'}
                        icon={<Icons.add />}
                        title='Dodaj użytkownika do projektu'
                    />
                )}
            </div>
            <SimpleTable
                detailKey={'oper_profile'}
                columns={createTableListaProfiliProjektu()}
                addTh={th}
                addTd={td}
                data={listaPozycji.data || []}
            />
        </>
    )
}

ViewListaProfiliProjektu.propTypes = {
    moje: PropTypes.bool,
}

export default ViewListaProfiliProjektu
